import { createStore } from 'vuex'
import order from './modules/order'
import fitmentRisk from './modules/fitmentRisk'

export default createStore({
  modules: {
    order,
    fitmentRisk
  }
})
